import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type T3DSecureEnrolmentHistoryDataTableData = {
  primaryKey: string | number,
  operationDate: string,
  cardNumber: string,
  holderName: string,
  dateSentACS: string,
  sendingACS: string,
  returnACS: string,
  reason: string,
  phoneNumber: string,
  operationType: string,
  
};

type Props = {
  isLoading: boolean | undefined
};

const columnHelper = createColumnHelper<T3DSecureEnrolmentHistoryDataTableData>();

export function get3DSecureEnrolmentHistoryDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('operationDate', {
      id: 'operationDate',
      header: 'Date Opér.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cardNumber', {
      id: 'cardNumber',
      header: 'N° Carte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('holderName', {
      id: 'holderName',
      header: 'Nom Porteur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dateSentACS', {
      id: 'dateSentACS',
      header: 'Date Envoi ACS',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('sendingACS', {
      id: 'sendingACS',
      header: 'Envoi ACS',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('returnACS', {
      id: 'returnACS',
      header: 'Retour ACS',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('reason', {
      id: 'reason',
      header: 'Motif',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('phoneNumber', {
      id: 'phoneNumber',
      header: 'N° Tél',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('operationType', {
      id: 'operationType',
      header: 'Type Opér.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

  ];
}
